import Latest from "./Latest";
import Technologies from "./Technologies";
import ContactMe from "./ContactMe";

export default function Home() {
  return (
    <div>
      <Latest />
      <Technologies />
      <ContactMe />
    </div>
  );
}
